import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";
import cheronUpdown from "assets/icons/cheron-updown.svg";
import PopupSelectMode from "components/section-m-24/PopupSelectMode";
import PopupVerifyProjectId from "components/section-m-24/PopupVerifyProjectId";
import { M24_CONFIG_DOC } from "libs/configs/constant";
import { HOME_TAB } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import { get } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  m24SwitchModeSlice,
  selectM24SwitchMode,
} from "redux/modules/m24SwitchModeSlice";
import {
  getSmartCompany,
  selectIsChamber,
  selectSmartCompany,
  selectUpdateSmartCompanyConditionType,
  updateSmartCompanyConditionType,
} from "redux/modules/smartCompanySlice";
import { setHomeTab } from "redux/modules/uiSlice";
import { getDocumentRequired } from "redux/modules/visaForm";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flex: 1,
    padding: "10px 20px",
    minWidth: 230,
  },
  iconUpdown: {
    height: 13,
    alignSelf: "center",
  },
  textButton: {
    justifyContent: "flex-start",
    color: "#F53C56",
  },
}));

export default function M24SwitchModeButton() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [menus, setMenus] = useState([]);

  const [isModalSelectM24ModeVisible, setModalSelectM24ModeVisible] =
    useState(false);
  const [isModalVerifyVisible, setModalVerifyVisible] = useState(false);

  const { showLoading, hideLoading } = useModalLoading();

  const m24SwitchMode = useSelector(selectM24SwitchMode);
  const isChamber = useSelector(selectIsChamber);
  const userProfile = useSelector((state) => state.user.profile);
  const smartCompanyID = get(userProfile, "smartCompanyID", null);
  const updateSmartCompanyConditionTypeState = useSelector(
    selectUpdateSmartCompanyConditionType
  );

  const defaultValue =
    m24SwitchMode === null || m24SwitchMode === "PENDING" ? "" : m24SwitchMode;
  const [mode, setMode] = useState(defaultValue);

  const { isSuccess: isSuccessSmartCompany, isLoading: isLoadingSmartCompany } =
    useSelector(selectSmartCompany);

  const shouldVisiblePopupSelectMode =
    isSuccessSmartCompany &&
    !isChamber &&
    (m24SwitchMode === null || m24SwitchMode === "PENDING");

  const smartserviceId = M24_CONFIG_DOC[mode]?.SMART_SERVICE_ID || null;

  useEffect(() => {
    if (shouldVisiblePopupSelectMode) {
      setModalSelectM24ModeVisible(true);
    }
  }, [shouldVisiblePopupSelectMode]);

  useEffect(() => {
    if (isChamber) {
      setMenus([
        { title: "หอการค้า", value: M24_CONFIG_DOC.COC.CONDITION_TYPE },
      ]);
    } else {
      setMenus([
        {
          title: "บริษัทที่อยู่ระหว่างการส่งเสริม",
          value: M24_CONFIG_DOC.COM.CONDITION_TYPE,
        },
        {
          title: "ศึกษาลู่ทางการลงทุน",
          value: M24_CONFIG_DOC.INV.CONDITION_TYPE,
        },
      ]);
    }
  }, [isChamber]);

  useEffect(() => {
    if (!updateSmartCompanyConditionTypeState.isLoading) {
      if (updateSmartCompanyConditionTypeState.isSuccess) {
        hideLoading();
        dispatch(setHomeTab(HOME_TAB.EMPLOYEE_LIST));
        dispatch(getDocumentRequired({ smartserviceId, ConditionType: mode }));
        dispatch(getSmartCompany(smartCompanyID));
      } else if (updateSmartCompanyConditionTypeState.isFailure) {
        hideLoading();
      }
    }
  }, [updateSmartCompanyConditionTypeState, dispatch]);

  const handleClick = (event) => {
    if (!isChamber) {
      // setAnchorEl(event.currentTarget);
      setModalSelectM24ModeVisible(true);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickItem = (menu) => () => {
    dispatch(m24SwitchModeSlice.actions.setMode(menu.value));
    handleClose();
  };

  const handleModalSelectm24Close = () => {
    setModalSelectM24ModeVisible(false);
    setMode(defaultValue);
  };

  const handleOnSelectM24ModeSubmit = () => {
    setModalSelectM24ModeVisible(false);
    setTimeout(() => {
      if (mode === M24_CONFIG_DOC.COM.CONDITION_TYPE) {
        setModalVerifyVisible(true);
      } else {
        dispatch(
          updateSmartCompanyConditionType({
            conditionType: mode,
            smartCompanyID,
          })
        );
        showLoading();
      }
    }, 350);
  };

  const handleModalVerifyClose = () => {
    setModalVerifyVisible(false);
    setTimeout(() => {
      setModalSelectM24ModeVisible(true);
    }, 350);
  };

  const handleModalVerifySubmit = () => {
    setModalVerifyVisible(false);
    dispatch(
      updateSmartCompanyConditionType({ conditionType: mode, smartCompanyID })
    );
    showLoading();
  };

  return (
    <div className={classes.container}>
      <Button
        aria-controls="m24-switch-menu"
        aria-haspopup="true"
        onClick={handleClick}
        fullWidth
        className={classes.textButton}
      >
        {!m24SwitchMode || m24SwitchMode === "PENDING"
          ? ".."
          : menus.find((v) => v.value === m24SwitchMode)?.title || ""}
      </Button>
      {/* <Menu
        id="m24-switch-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {menus.map((menu, index) => (
          <MenuItem key={index} onClick={handleClickItem(menu)}>
            {menu.title}
          </MenuItem>
        ))}
      </Menu> */}
      <img
        alt="cheron-updown.svg"
        src={cheronUpdown}
        className={classes.iconUpdown}
      />

      <Dialog
        hideBackdrop={false}
        open={isModalSelectM24ModeVisible}
        // onClose={handleModalSelectm24Close}
        maxWidth="lg"
        keepMounted={false}
        id="PopupSelectMode"
      >
        <DialogContent>
          <PopupSelectMode
            onCancel={handleModalSelectm24Close}
            onSubmit={handleOnSelectM24ModeSubmit}
            onChange={setMode}
            value={mode}
          />
        </DialogContent>
      </Dialog>
      <Dialog
        open={isModalVerifyVisible}
        // onClose={handleModalVerifyClose}
        maxWidth="lg"
        keepMounted={false}
        id="PopupVerifyProjectId"
      >
        <DialogContent>
          <PopupVerifyProjectId
            onCancel={handleModalVerifyClose}
            onSubmit={handleModalVerifySubmit}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
